var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.65 5.33333V5.43333H9.75H10.5C11.2683 5.43333 11.9 6.07279 11.9 6.85714V14.4762C11.9 15.2605 11.2683 15.9 10.5 15.9H1.5C0.731707 15.9 0.1 15.2605 0.1 14.4762V6.85714C0.1 6.07279 0.731707 5.43333 1.5 5.43333H2.25H2.35V5.33333V3.80952C2.35 1.7604 3.98671 0.1 6 0.1C8.01329 0.1 9.65 1.7604 9.65 3.80952V5.33333ZM8.25 5.43333H8.35V5.33333V3.80952C8.35 2.49102 7.30171 1.42381 6 1.42381C4.69829 1.42381 3.65 2.49102 3.65 3.80952V5.33333V5.43333H3.75H8.25ZM10.5 14.5762H10.6V14.4762V6.85714V6.75714H10.5H1.5H1.4V6.85714V14.4762V14.5762H1.5H10.5ZM7.4 10.6667C7.4 11.451 6.76829 12.0905 6 12.0905C5.23171 12.0905 4.6 11.451 4.6 10.6667C4.6 9.88231 5.23171 9.24286 6 9.24286C6.76829 9.24286 7.4 9.88231 7.4 10.6667Z",
    fill: "#000",
    stroke: "#202d57",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.32c769077055ca130543a81f629449ed.svg";
export { ForwardRef as ReactComponent };